import React from 'react'
import './Spinner.css'
const Spinner  = () =>{
    return(
        <div>
             <div className="backdrop"></div>
             <div className="spinner-container">
                 <div className="Spinner">Loading... </div>
             </div>
        </div>
    )
}

export default Spinner